// Centralized helpers for placement rule UI labels

/**
 * Map bowlerQuantity and maxSharedPlayers to a human-readable label
 * exactly matching the app's copy across components.
 */
export const getPlacementRuleLabel = (bowlerQuantity, maxSharedPlayers) => {
  const q = Number(bowlerQuantity);
  const m = maxSharedPlayers;

  if (q === 1) {
    return m === 0 ? "Can only place once" : "Can place multiple times";
  }

  if (q === 2) {
    return m === 1
      ? "Can only place once with the same partner"
      : "Can place multiple times with the same partner";
  }

  if (q === 3) {
    return m === 2
      ? "No more than 2 of the same bowlers"
      : "Can place multiple times with the same team";
  }

  if (q === 4) {
    if (m === 2) return "No more than 2 of the same bowlers";
    if (m === 3) return "No more than 3 of the same bowlers";
    return "Can place multiple times with the same team";
  }

  if (q === 5) {
    if (m === 2) return "No more than 2 of the same bowlers";
    if (m === 3) return "No more than 3 of the same bowlers";
    if (m === 4) return "No more than 4 of the same bowlers";
    return "Can place multiple times with the same team";
  }

  // Fallback generic for unexpected sizes
  if (m == null) return "Can place multiple times with the same team";
  return `No more than ${m} of the same bowlers`;
};

/**
 * Get the allowed select values for a given bowlerQuantity.
 * Values are strings: numeric thresholds or "null" for no restriction.
 */
export const getAllowedPlacementValues = (bowlerQuantity) => {
  const q = Number(bowlerQuantity);
  if (q === 1) return ["0", "null"];
  if (q === 2) return ["1", "null"];
  if (q === 3) return ["null", "2"];
  if (q === 4) return ["null", "2", "3"];
  if (q === 5) return ["null", "2", "3", "4"];
  // Fallback (should not be used in current UI)
  return ["null", "2", "3"];
};

/**
 * Recommended default selection (as string) by bowlerQuantity.
 */
export const getRecommendedPlacementValue = (bowlerQuantity) => {
  const q = Number(bowlerQuantity);
  if (q === 1) return "0";
  if (q === 2) return "1";
  return "2"; // teams default
};
